export default __webpack_public_path__ + "images/onboardFooterImage.dd3a1981.svg";